import React, { useMemo } from "react";
import { DishCard } from "../dish/DishCard";
import { ConsumedIntakeEditor } from "../intake/ConsumedIntakeEditor";
import { IntakeWithEditedFlags, PlanCell } from "../../data/plan";
import { usePurchase } from "../../queries/caches";
import { formatPurchaseDescription } from "../../utils/purchaseUtils";
import { useConsumedNutri } from "./intakeLookups";

export function ConsumedEntryCard(props: {
  cell: PlanCell;
  personName?: string;
  expanded: boolean;
  onToggleExpand: () => void;
  onPatchIntake: (
    index: number,
    mutate: (i: IntakeWithEditedFlags) => void,
  ) => void;
  onOpenProductPicker: (index: number) => void;
  onRemoveIntake: (index: number) => void;
}) {
  const purchase = usePurchase(
    props.cell.indicator === "MealWithIntakes"
      ? undefined
      : props.cell.purchaseUnitPurchaseId,
  );
  const intakes = useMemo<IntakeWithEditedFlags[]>(
    () =>
      props.cell.indicator === "MealWithIntakes"
        ? props.cell.intakes ?? []
        : [props.cell],
    [props.cell],
  );
  const description =
    props.cell.indicator === "MealWithIntakes"
      ? props.cell.meal.dishDescription ||
        props.cell.meal.foodDescription ||
        props.cell.meal.purchaseDescription ||
        ""
      : formatPurchaseDescription(purchase) ||
        props.cell.purchaseUnitPurchaseDescription;
  const nutri = useConsumedNutri(intakes);

  return (
    <DishCard
      dataCy="verzehr-consumed-card"
      title={description}
      personName={props.personName}
      kcal={nutri.kcal}
      nutri={nutri}
      expanded={props.expanded}
      onToggleExpand={props.onToggleExpand}
      titleDataCy="verzehr-consumed-card-title"
    >
      <ConsumedIntakeEditor
        intakes={intakes}
        mealIngredients={
          props.cell.indicator === "MealWithIntakes"
            ? props.cell.meal.mealIngredients
            : undefined
        }
        onPatchIntake={props.onPatchIntake}
        onOpenProductPicker={props.onOpenProductPicker}
        onRemoveIntake={props.onRemoveIntake}
      />
    </DishCard>
  );
}
